import React, { Component } from 'react';
import emailjs from 'emailjs-com';
import homedata from '../../data/home.json';

class Contact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sending: false,
            success: false,
            error: false,
        };
        this.sendEmail = this.sendEmail.bind(this);
    }

    sendEmail(e) {
        e.preventDefault();
        this.setState({ sending: true });

        emailjs.sendForm('service_wf2on1d', 'template_1oyw9v2', e.target, '3x5Rq3cgGKaQBlmuK')
            .then((result) => {
                console.log(result.text);
                this.setState({ sending: false, success: true });
            }, (error) => {
                console.log(error.text);
                this.setState({ sending: false, error: true });
            });
    }

    render() {
        let contactInfo = homedata.contact;
        let sectionHeadingInfo = contactInfo.sectionHeading;
        let publicUrl = process.env.PUBLIC_URL;
        let inlineStyle = {
            backgroundImage: 'url(' + publicUrl + contactInfo.bgImg + ')'
        };

        return (
            <section id="contact" className="pt100 pb100 bg-parallax" style={inlineStyle}>
                <div className="color-overlay opacity-8"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2">
                            <div className="contact-block text-center">
                                <div className="col-sm-12">
                                    <h3>{sectionHeadingInfo.title}</h3>
                                    <p className="subtitle">{sectionHeadingInfo.desc}</p>
                                </div>
                                {this.state.success ? (
                                    <div className="message col-lg-12">
                                        <p className="col-sm-12">
                                            <i className="icon fa fa-check fa-3x" style={{ color: 'green' }}></i>
                                            <br />
                                            Your message has been successfully sent. Thank you!
                                        </p>
                                    </div>
                                ) : (
                                    <form id="contact-form" onSubmit={this.sendEmail}>
                                        <div className="message col-lg-12">
                                            {this.state.sending && (
                                                <p className="email-loading">
                                                    <img src={`${publicUrl}/assets/img/loading.gif`} alt="loading" />
                                                    &nbsp;&nbsp;&nbsp;Sending...
                                                </p>
                                            )}
                                            {this.state.error && (
                                                <p className="email-failed">
                                                    <i className="icon fa fa-times"></i> Something went wrong!
                                                </p>
                                            )}
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <input
                                                    name="user_name"
                                                    className="contact-name form-control input-box"
                                                    id="user_name"
                                                    type="text"
                                                    placeholder="Your Name"
                                                    required
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <input
                                                    name="user_email"
                                                    className="contact-email form-control input-box"
                                                    id="user_email"
                                                    type="email"
                                                    placeholder="Your Email"
                                                    required
                                                />
                                            </div>
                                            <div className="col-sm-12">
                                                <input
                                                    name="from_subject"
                                                    className="contact-subject form-control input-box"
                                                    id="from_subject"
                                                    type="text"
                                                    placeholder="Subject"
                                                    required
                                                />
                                            </div>
                                            <div className="col-sm-12">
                                                <textarea
                                                    name="message"
                                                    className="contact-message form-control textarea-box"
                                                    id="message"
                                                    placeholder="Your Message"
                                                    required
                                                ></textarea>
                                            </div>
                                            <div className="col-sm-12">
                                                <button className="primary-btn" type="submit" disabled={this.state.sending}>
                                                    <i className="fa fa-paper-plane" aria-hidden="true"></i> {contactInfo.submitBtnLabel}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Contact;
